export default __webpack_public_path__ + "static/Cover-3273d5c8b7fc221070fe67cc56b4b886.png";